export default __webpack_public_path__ + "static/media/Family.2f22dd73.svg";